import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import history from "../../auth/history";
import XMLParser from 'react-xml-parser';

import { v4 as uuidv4 } from 'uuid';
import { store } from "../../redux/store";
import $ from 'jquery';
import { setOtpResponse } from "../../redux/misc-data/misc-data.action";
import { setAgentInfo } from './../../redux/misc-data/misc-data.action';

var finalUrl = "";
var MethodInfo = "";
var MethodCapture = "";
var finalport = "";
var is_capture = false;
var finalRdServiceResponse = [];
var btnText = '';
var biomatricIndicater = '';
var deviceInfo = '';
var deviceErrorMsg = '';
var deviceErrorCode = '';
var capturedData = '';
const httpClient = axios.create();

class AddSender extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            refId: '',
            shopName: '',
            mobile: '',
            agentFullName: "PRAKASH RAM JHUNJHUNWALA",
            agentPan: "AAIPM3854E",
            agentDateOfBirth: "22/07/1989",

            //response
            otpToken: '',
            kycToken: '',
            wadh: '',
            captureStatus: 'Off',

            version: '',
            serialNum: '',
            timeStamp: '',
            deviceXmlData: '',
            biomatricDeviceIndicaterClass: '',
            biomatricDeviceIndicater: '',
            submitBtnStatus: false,
            aadharNumber: '',
            req: ''



        }
    }

    enterRefId = (event) => {
        this.setState({
            refId: event.target.value
        })
    }

    enterShop = (event) => {
        this.setState({
            shopName: event.target.value
        })
    }

    enterMobile = (event) => {
        this.setState({
            mobile: event.target.value
        })
    }

    enterAadhar = (event) => {
        this.setState({
            aadharNumber: event.target.value
        })
    }

    captureData() {
        this.setState({ submitBtnStatus: true });
        setTimeout(() => {
            //  if (is_capture == true) {
            var captureData = this.capture();

            /* var parser = new DOMParser();
             var xmlDoc = parser.parseFromString(finalRdServiceResponse, "text/xml");
             console.log("xmlDoc___", xmlDoc); */
            console.log("captureData___", captureData.data);

            capturedData = captureData.data;
            var Fingerprintxml = new XMLParser().parseFromString(captureData.data);

            console.log("Fingerprintxml ff", Fingerprintxml);
            var errCode = Fingerprintxml.children[0].attributes.errCode != undefined ? Fingerprintxml.children[0].attributes.errCode : '';

            Fingerprintxml.children[2].attributes.ci = "20221023"

            var versionV = Fingerprintxml.children[1].attributes.rdsVer
            var serialNumV = Fingerprintxml.children[1].children[0].children[0].attributes.value
            var timeStampV = Fingerprintxml.children[1].children[0].children[1].attributes.value

            this.setState({
                version: versionV,
                serialNum: serialNumV,
                timeStamp: timeStampV

            })

            //console.log("Fingerprintxml_data_",Fingerprintxml.children[0].attributes.errCode);
            if (errCode == 0) {
                // this.setState({ CaptureFingerprintData: Fingerprintxml });
                // store.dispatch(showAEPSCASHWITHDEAWALSection());
                alert("Finger Print capture successfully.");
                this.setState({ showModal: false });
                this.setState({ messagePopUpHidden: true })
                this.setState({ message: "Finger Print capture successfully." });
                this.setState({ severity: "success" });
                // store.dispatch(setBioMetricEncryptionXML({ bioMetricEncryptionXML: captureData.data }));
                // var xmlDta = '<?xml version="1.0"?><PidData><Resp errCode="0" errInfo="Success" fCount="1" fType="0" nmPoints="33" qScore="100" /><DeviceInfo dpId="MANTRA.MSIPL" rdsId="MANTRA.WIN.001" rdsVer="1.0.2" mi="MFS100" mc="MIIEGDCCAwCgAwIBAgIEAV7zwDANBgkqhkiG9w0BAQsFADCB6jEqMCgGA1UEAxMhRFMgTWFudHJhIFNvZnRlY2ggSW5kaWEgUHZ0IEx0ZCA3MUMwQQYDVQQzEzpCIDIwMyBTaGFwYXRoIEhleGEgb3Bwb3NpdGUgR3VqYXJhdCBIaWdoIENvdXJ0IFMgRyBIaWdod2F5MRIwEAYDVQQJEwlBaG1lZGFiYWQxEDAOBgNVBAgTB0d1amFyYXQxHTAbBgNVBAsTFFRlY2huaWNhbCBEZXBhcnRtZW50MSUwIwYDVQQKExxNYW50cmEgU29mdGVjaCBJbmRpYSBQdnQgTHRkMQswCQYDVQQGEwJJTjAeFw0yMDExMDIwODQ2MzdaFw0yMDExMTMxODQwMjNaMIGwMSUwIwYDVQQDExxNYW50cmEgU29mdGVjaCBJbmRpYSBQdnQgTHRkMR4wHAYDVQQLExVCaW9tZXRyaWMgTWFudWZhY3R1cmUxDjAMBgNVBAoTBU1TSVBMMRIwEAYDVQQHEwlBSE1FREFCQUQxEDAOBgNVBAgTB0dVSkFSQVQxCzAJBgNVBAYTAklOMSQwIgYJKoZIhvcNAQkBFhVzdXBwb3J0QG1hbnRyYXRlYy5jb20wggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQDAAyBJPuOKgWQEuZ2BEUvhwrBNjR3UrmO4L2Fv9CkRj9mu/AJLisKRIYB/z92di0jAaWoUP5UNQvp5EIAGhHQ2js9OawKfGOY65P51lIu8of6zR1bRajzxMxmRAvxekFQRHi1nQeYxUtLklznQOF2SImSPq0J9rhsp++KUnfqNIw9GQXZN3Hyk22Hgpq4Kl3Eu29VmnvdcaRaKWQ1C4fMaJka9D1+UyJBivfKAdGlDsHk/hAvCtwE74HrWwz5sKQskQevYlklEx1B/XgYKMfuZqcex5NCfTvXAmHMbKZp07sb37vb1Ga/mm/eZfVlUqZomobmoS0dUSxRrECZy/BI1AgMBAAEwDQYJKoZIhvcNAQELBQADggEBAFB9zzyZEpqGAloAnd/u6QbfKHvllQf9y1kGlPwPtx1xbHdewgl9l7Fo1JO7A8s3AQCf54brYnOusxO3SHB5QVyU6F3zDjDb6YEwAF6YjSe5n93NBhZbMIeL5QIOe3Fb0AP7+MEFcs2anMElzBVucHK6+p7hekSwIYSMYUvXO5jd7ZwjroduAJZmIhDiVn0ZFquExLJkGH7CmECZe/WAfdqt2LxYrQ0zG9oJlPZErSa06ARMLotxF4O3n/tvKHbJ4S4gpa3N4z0xIzxrAuHB/31ozTKg5ygsVlDr9YJ9pJedZFnTcP9JM+ycRYhR+Jq+tyWGxPCcwMiPwkRELj7DTww=" dc="29a62505-34ad-46c5-b6c6-c08e7c366fff"><additional_info><Param name="srno" value="3291614" /><Param name="sysid" value="651FEBF28048157FBFF0" /><Param name="ts" value="2020-11-03T12:36:35+05:30" /></additional_info></DeviceInfo><Skey ci="20221021">LSKN0KhQ3yWgBcdgU0zqvIEoFW8zmonyybUGRt6AbnWSbeJwxA9twzuzFErjkuf2zuJKoaaaou0y/pteTdVV7bS+Y05RpOllWrwiCokRipHxq7FQh0L+uJVoTtZHZxElie+gH7FSVGaTSNoCF6g4PZvSAgGOVdobWBxoRP70E6F/bSHtli80OLXkqGouanCz9PGAQrg11gUs/iTlobKjuvXs1XYzgpDJ77RJ88hZCi4uizTOFQIWU5aniRK9PVjToAgETwWzCsP/kpbjfIL9OB3AGagVOqylU9FXd52YNQbqClUzUwOALL1g3uBbrAU1f7cXJoWwbrJR+I2ifcGJag==</Skey><Hmac>qs+ewZXelPNZwjjgEMbQO+OZFv3sZWA3CIrPrKbw1XHJz4dX/nEM1tXaQDUdrRgl</Hmac><Data type="X">MjAyMC0xMS0wM1QxMjozNjozNTuSSVJXVXyQERLWbBYaiz88Mkjl4Kk+kWMjoR1ukYAjqHr3H8vQGejjvpTAZJupjk6ECug7TLowGJsO/XPOrpggj1ADV5JCreL9gmk9enL8ECdy6PhUgfxKsSzriKR1q6y8srKM9pfefx18DJ6fXED+p4CBUCzFQzBe4S8crQ3j39jvfju1nig/hYNZWNUBgvEKO0zFY3rw/OR0RDQZ2g2y0Skt/AXsxoe5bKShyc2na9T7RIWIcteeEPGBf9yseps+CgTKPjcjaqNyGBbM0/MDo6IwKlQOY9fHf4L4ypE+txGkfO9F9Y37AKfmniMmO9kKgN3Ow8iwkmXhJDDONrwHeCphCj9Js+KwgoMLSbCVf61KDQjuUun1dmgQxhbYc1hAkYjdiG5X9m7NTZD4/V/rKipktcYokYGKvde8PDaKTPO6hNIqD4AtgcZrEDbXsI05DFru02Vkd+zdx18KHb3KPvl5rlbG9YVN2Jp5jyiO3bAbGhxDs4GYbC0J2wDnsojyWhVWZxAXFkO1aQm/v+bdEHCmlUt0stkpO9fCNpV2PJhfwND1RCsC1JLwkbn+OsTTyBPwcQ+OBOBkqn13GUmMla6kSSWz+d67Z6OOKAdL4Iqj4HRlVh17qpGiXz6umiJ5zSkToVqHHAhjr596Gkmzi7rwRvCaIY2D+TWPUKHlwuvOkq7rH5oUBOKD7emxO3Hpf+y3CytWRVFUslAEqbSjX0YAiVnsMJOyZFzzVDuAsp6J5jCtyZfTHiXY05RDz7ejkDMh4xftAJCFLiYmZ8O2eGNtZGBB97OUX2iKcsMBhbKZyb6CacQiQCE0cLEcQnelbnpyp3iiumHcUiYNOU0k2bo+M6t1v8w4yN2uUzPDw2unIxKRzg1jyvM2Mj7mjLJH95aTTL8C9bJz3PBz1LnVz1MscXnW1/hsJ+zDUc9Q6fek/scZ1l59CGVgvA/EBIwwpVeiWWMeDm0QIgggryInBhOpyObcDOVCwSAvr8S+RIbDxuUJ09+tcw1o/4y2hgaolyuDkGOjgnVLr8dgWIHfc8DooCajH/woEtdPvgJBRr+ozVvO4v4DoSRuCiETtNenvVY7TNayrel0opWgL+8e+odhxw05ydfBBe73IVICUdtT10v37uf14XrW7u5sZJAmZ/QKmJkM/fya6B5ZWRPq6KbuxCOawqVtFNkiwvoKvrezqJHqb5E=</Data></PidData>';
                var xmlDta = captureData.data;
                console.log(captureData.data, " capture format must be ", '<?xml version="1.0"?><PidData><Resp errCode="0" errInfo="Success" fCount="1" fType="0" nmPoints="33" qScore="100" /><DeviceInfo dpId="MANTRA.MSIPL" rdsId="MANTRA.WIN.001" rdsVer="1.0.2" mi="MFS100" mc="MIIEGDCCAwCgAwIBAgIEAV7zwDANBgkqhkiG9w0BAQsFADCB6jEqMCgGA1UEAxMhRFMgTWFudHJhIFNvZnRlY2ggSW5kaWEgUHZ0IEx0ZCA3MUMwQQYDVQQzEzpCIDIwMyBTaGFwYXRoIEhleGEgb3Bwb3NpdGUgR3VqYXJhdCBIaWdoIENvdXJ0IFMgRyBIaWdod2F5MRIwEAYDVQQJEwlBaG1lZGFiYWQxEDAOBgNVBAgTB0d1amFyYXQxHTAbBgNVBAsTFFRlY2huaWNhbCBEZXBhcnRtZW50MSUwIwYDVQQKExxNYW50cmEgU29mdGVjaCBJbmRpYSBQdnQgTHRkMQswCQYDVQQGEwJJTjAeFw0yMDExMDIwODQ2MzdaFw0yMDExMTMxODQwMjNaMIGwMSUwIwYDVQQDExxNYW50cmEgU29mdGVjaCBJbmRpYSBQdnQgTHRkMR4wHAYDVQQLExVCaW9tZXRyaWMgTWFudWZhY3R1cmUxDjAMBgNVBAoTBU1TSVBMMRIwEAYDVQQHEwlBSE1FREFCQUQxEDAOBgNVBAgTB0dVSkFSQVQxCzAJBgNVBAYTAklOMSQwIgYJKoZIhvcNAQkBFhVzdXBwb3J0QG1hbnRyYXRlYy5jb20wggEiMA0GCSqGSIb3DQEBAQUAA4IBDwAwggEKAoIBAQDAAyBJPuOKgWQEuZ2BEUvhwrBNjR3UrmO4L2Fv9CkRj9mu/AJLisKRIYB/z92di0jAaWoUP5UNQvp5EIAGhHQ2js9OawKfGOY65P51lIu8of6zR1bRajzxMxmRAvxekFQRHi1nQeYxUtLklznQOF2SImSPq0J9rhsp++KUnfqNIw9GQXZN3Hyk22Hgpq4Kl3Eu29VmnvdcaRaKWQ1C4fMaJka9D1+UyJBivfKAdGlDsHk/hAvCtwE74HrWwz5sKQskQevYlklEx1B/XgYKMfuZqcex5NCfTvXAmHMbKZp07sb37vb1Ga/mm/eZfVlUqZomobmoS0dUSxRrECZy/BI1AgMBAAEwDQYJKoZIhvcNAQELBQADggEBAFB9zzyZEpqGAloAnd/u6QbfKHvllQf9y1kGlPwPtx1xbHdewgl9l7Fo1JO7A8s3AQCf54brYnOusxO3SHB5QVyU6F3zDjDb6YEwAF6YjSe5n93NBhZbMIeL5QIOe3Fb0AP7+MEFcs2anMElzBVucHK6+p7hekSwIYSMYUvXO5jd7ZwjroduAJZmIhDiVn0ZFquExLJkGH7CmECZe/WAfdqt2LxYrQ0zG9oJlPZErSa06ARMLotxF4O3n/tvKHbJ4S4gpa3N4z0xIzxrAuHB/31ozTKg5ygsVlDr9YJ9pJedZFnTcP9JM+ycRYhR+Jq+tyWGxPCcwMiPwkRELj7DTww=" dc="29a62505-34ad-46c5-b6c6-c08e7c366fff"><additional_info><Param name="srno" value="3291614" /><Param name="sysid" value="651FEBF28048157FBFF0" /><Param name="ts" value="2020-11-03T12:36:35+05:30" /></additional_info></DeviceInfo><Skey ci="20221023">LSKN0KhQ3yWgBcdgU0zqvIEoFW8zmonyybUGRt6AbnWSbeJwxA9twzuzFErjkuf2zuJKoaaaou0y/pteTdVV7bS+Y05RpOllWrwiCokRipHxq7FQh0L+uJVoTtZHZxElie+gH7FSVGaTSNoCF6g4PZvSAgGOVdobWBxoRP70E6F/bSHtli80OLXkqGouanCz9PGAQrg11gUs/iTlobKjuvXs1XYzgpDJ77RJ88hZCi4uizTOFQIWU5aniRK9PVjToAgETwWzCsP/kpbjfIL9OB3AGagVOqylU9FXd52YNQbqClUzUwOALL1g3uBbrAU1f7cXJoWwbrJR+I2ifcGJag==</Skey><Hmac>qs+ewZXelPNZwjjgEMbQO+OZFv3sZWA3CIrPrKbw1XHJz4dX/nEM1tXaQDUdrRgl</Hmac><Data type="X">MjAyMC0xMS0wM1QxMjozNjozNTuSSVJXVXyQERLWbBYaiz88Mkjl4Kk+kWMjoR1ukYAjqHr3H8vQGejjvpTAZJupjk6ECug7TLowGJsO/XPOrpggj1ADV5JCreL9gmk9enL8ECdy6PhUgfxKsSzriKR1q6y8srKM9pfefx18DJ6fXED+p4CBUCzFQzBe4S8crQ3j39jvfju1nig/hYNZWNUBgvEKO0zFY3rw/OR0RDQZ2g2y0Skt/AXsxoe5bKShyc2na9T7RIWIcteeEPGBf9yseps+CgTKPjcjaqNyGBbM0/MDo6IwKlQOY9fHf4L4ypE+txGkfO9F9Y37AKfmniMmO9kKgN3Ow8iwkmXhJDDONrwHeCphCj9Js+KwgoMLSbCVf61KDQjuUun1dmgQxhbYc1hAkYjdiG5X9m7NTZD4/V/rKipktcYokYGKvde8PDaKTPO6hNIqD4AtgcZrEDbXsI05DFru02Vkd+zdx18KHb3KPvl5rlbG9YVN2Jp5jyiO3bAbGhxDs4GYbC0J2wDnsojyWhVWZxAXFkO1aQm/v+bdEHCmlUt0stkpO9fCNpV2PJhfwND1RCsC1JLwkbn+OsTTyBPwcQ+OBOBkqn13GUmMla6kSSWz+d67Z6OOKAdL4Iqj4HRlVh17qpGiXz6umiJ5zSkToVqHHAhjr596Gkmzi7rwRvCaIY2D+TWPUKHlwuvOkq7rH5oUBOKD7emxO3Hpf+y3CytWRVFUslAEqbSjX0YAiVnsMJOyZFzzVDuAsp6J5jCtyZfTHiXY05RDz7ejkDMh4xftAJCFLiYmZ8O2eGNtZGBB97OUX2iKcsMBhbKZyb6CacQiQCE0cLEcQnelbnpyp3iiumHcUiYNOU0k2bo+M6t1v8w4yN2uUzPDw2unIxKRzg1jyvM2Mj7mjLJH95aTTL8C9bJz3PBz1LnVz1MscXnW1/hsJ+zDUc9Q6fek/scZ1l59CGVgvA/EBIwwpVeiWWMeDm0QIgggryInBhOpyObcDOVCwSAvr8S+RIbDxuUJ09+tcw1o/4y2hgaolyuDkGOjgnVLr8dgWIHfc8DooCajH/woEtdPvgJBRr+ozVvO4v4DoSRuCiETtNenvVY7TNayrel0opWgL+8e+odhxw05ydfBBe73IVICUdtT10v37uf14XrW7u5sZJAmZ/QKmJkM/fya6B5ZWRPq6KbuxCOawqVtFNkiwvoKvrezqJHqb5E=</Data></PidData>')
                console.log(captureData, " capture format must be")


                //this.submitBioMetricData(xmlDta);
                this.setState({
                    deviceXmlData: btoa(xmlDta)
                })
                // this.submitBioMetricData(captureData.data);
            } else {
                var errInfo = Fingerprintxml.children[0].attributes.errInfo != undefined ? Fingerprintxml.children[0].attributes.errInfo : '';
                alert('error in fingerprint capturing::' + errInfo);
                this.setState({ submitBtnStatus: false });
                // this.setState({ showModal: false });
                // this.setState({ messagePopUpHidden: true })
                // this.setState({ message: errInfo });
                // this.setState({ severity: "error" });
            }
            //  }
        }, 100);
    }


    captureFingerPrint = async () => {
        //this.getBioMetricEncryptionKey();

        if (this.state.biomatricDeviceIndicaterClass === '' || this.state.biomatricDeviceIndicaterClass === "disconnect") {
            // this.setState({ messagePopUpHidden: true })
            // this.setState({ message: process.env.REACT_APP_Message_for_device_not_connected });
            // this.setState({ severity: "error" });
            alert('Device not connected');
            this.captureData();
        } else {
            this.captureData();
        }
    }

    capture = (event) => {						// Get Capture Info from the path given by RDService Info

        var fCount = document.getElementById('txtfcount').value;
        var fType = 1;//document.getElementById('txtftype').value;
        // var fType = 'X';//document.getElementById('txtftype').value;
        var format = document.getElementById('txtformat').value;
        var pidver = document.getElementById('txtPidVer').value;
        var timeout = document.getElementById('txttimeout').value;
        var env = document.getElementById('txtenv').value;
        var lock = document.getElementById('txtlk').value;
        var iCount = 0;
        var iType = "";
        var pType = "";
        var pCount = 0;
        var wadh_value = this.state.wadh;
        //let finalUrl="http://127.0.0.1:11100";
        // finalUrl = process.env.REACT_APP_RDService_URL + finalport;
        finalUrl = 'http://127.0.0.1:' + finalport;
        console.log("Capture_", finalUrl);
        // Form input Pid OPtions for capture Input
        var XML = '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="' + fCount + '" fType="' + fType + '" format="' + format + '" pidVer="' + pidver +
            '" timeout="' + timeout + '" env="' + env + '" wadh="' + wadh_value + '"   /> <CustOpts> <Param name="LockingKey" value="' + lock + '" /> </CustOpts> </PidOptions>';
        //   var XML = '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="' + fCount + '" fType="' + fType + '" format="' + format + '" pidVer="' + pidver + '" timeout="' + timeout + '" env="' + env + '" wadh="' + wadh_value + '" /> <CustOpts> <Param name="LockingKey" value="' + lock + '" /> </CustOpts> </PidOptions>';
        //var XML = '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="' + fCount + '" fType="' + fType + '" format="' + format + '" pidVer="' + pidver + '" timeout="' + timeout + '" env="' + env + '" /> <CustOpts> <Param name="LockingKey" value="' + lock + '" /> </CustOpts> </PidOptions>';
        console.log("XML_data_", XML);
        var verb = "CAPTURE";
        var err = "";
        var res;
        $.support.cors = true;
        var httpStaus = false;
        var jsonstr = "";
        $.ajax({
            type: "CAPTURE",
            async: false,
            crossDomain: true,
            url: finalUrl + MethodCapture,
            data: XML,
            contentType: "text/xml; charset=utf-8",
            processData: false,
            success: function (data) {
                var xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                //alert(xmlstr);
                data = xmlstr;
                //alert(data);
                httpStaus = true;
                var isBiomatric = true;
                res = { httpStaus: httpStaus, data: data };
                finalRdServiceResponse = data;
                $('#txtPidData').val(data);
                $('#txtPidOptions').val(XML);
                var deviceErrorMsg = $($doc).find('Resp').attr('errInfo');
                deviceErrorCode = 0;
                var $doc = $.parseXML(data);
                var Message = $($doc).find('Resp').attr('errInfo');
            },
            error: function (msg) {
                var result = msg.status + msg.statusText + msg.responseText;
                res = { httpStaus: false, data: result };
                alert(msg.responseText)
                var deviceErrorMsg = "Please reconnect biomatric device.";
                deviceErrorCode = 1;
                console.log("Error in Finger print capture ", res);

            }
        });
        // wher biomatric device not connected
        console.log("deviceErrorCode_", deviceErrorCode);
        if (deviceErrorCode == 1) {
            alert('deviceErrorMsg...' + deviceErrorMsg);
            this.setState({ showModal: false });
            this.setState({ messagePopUpHidden: true })
            this.setState({ message: deviceErrorMsg });
            this.setState({ severity: "error" });
            return false;
        }

        this.setState({ isBiomatricConnected: false });

        //  return false;
        return res;

    }


    //rd service
    discoverRDService = () => {				// Search for the valid RDService from port 11100 to 11120
        var primaryUrl = 'http://127.0.0.1:';//"http://127.0.0.1:";
        //   alert(primaryUrl);
        var tempcount = 0;
        var url = "";
        $("#ddlRDS").empty();
        //alert("Discovering Precision RDService.\nPlease wait for some time.");

        for (var i = 11100; i <= 11120; i++) {
            var verb = "RDSERVICE";
            var err = "";

            //alert(i);
            var res;
            $.support.cors = true;
            var httpStaus = false;
            var jsonstr = "";
            var data = new Object();
            var obj = new Object();
            var xmlstr;
            console.log("primaryUrl_____", primaryUrl + i.toString())
            $.ajax({
                type: "RDSERVICE",
                async: false,
                crossDomain: true,
                url: primaryUrl + i.toString(),
                contentType: "text/xml; charset=utf-8",
                processData: false,
                cache: false,

                success: function (data) {
                    xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                    console.log("xmlstr___xmlstr", xmlstr);
                    try {
                        xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                        //alert(xmlstr);
                        data = xmlstr;

                        httpStaus = true;
                        res = { httpStaus: httpStaus, data: data };
                        //alert(data);		
                        finalUrl = primaryUrl + i.toString();

                        var $doc = $.parseXML(xmlstr);
                        var CmbData1 = $($doc).find('RDService').attr('status');
                        var CmbData2 = $($doc).find('RDService').attr('info');

                        $("#ddlRDS").append('<option value=' + i.toString() + '>Port : ' + i.toString() + ' Status : ' + CmbData1 + '(' + CmbData2 + ')</option>')
                        tempcount++;
                    }
                    catch (e) { }
                },
                error: function (msg) {
                    var result = msg.status + msg.statusText + msg.responseText;
                    res = { httpStaus: false, data: data };
                    // alert( result);
                    console.log("ajax_request_not msg", msg);
                    console.log("ajax_request_not ", result);

                }

            });

            if (xmlstr != null) {
                if (xmlstr.indexOf('Precision') > 0) {
                    //alert(xmlstr);

                    $("select#ddlRDS").prop('selectedIndex', tempcount - 1);
                    finalport = i.toString();
                    this.discoverFirstNode(i);
                    break;
                }
            }

        }
        return res;

    }

    discoverFirstNode = (PortNo) => {				// Get the Status of the RDService found by discoverRDService()
        $('#txtDeviceInfo').val('');
        $('#txtPidOptions').val('');
        $('#txtPidData').val('');

        //alert(PortNo);

        var primaryUrl = 'http://127.0.0.1:';//"http://127.0.0.1:";
        let url = "";
        var verb = "RDSERVICE";
        var err = "";
        var res;
        $.support.cors = true;
        var httpStaus = false;
        var jsonstr = "";
        var data = new Object();
        var obj = new Object();

        $.ajax({
            type: "RDSERVICE",
            async: false,
            crossDomain: true,
            url: primaryUrl + PortNo,
            contentType: "text/xml; charset=utf-8",
            processData: false,
            cache: false,
            async: false,
            crossDomain: true,
            success: function (data) {
                var xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                //alert(xmlstr);
                data = xmlstr;
                //alert(data);
                httpStaus = true;
                res = { httpStaus: httpStaus, data: data };
                //alert(data);		
                $('#txtRDSInfo').val(data);

                var $doc = $.parseXML(data);

                for (var j = 0; j < 2; j++) {
                    if ($($doc).find('Interface').eq(j).attr('id') == 'CAPTURE') {
                        MethodCapture = $($doc).find('Interface').eq(j).attr('path');
                    } else if ($($doc).find('Interface').eq(j).attr('id') == 'DEVICEINFO') {
                        MethodInfo = $($doc).find('Interface').eq(j).attr('path');
                    }
                }

                console.log("Precision RDSERVICE Discover Successfully");
                var parser = new DOMParser();
                var device1_response = parser.parseFromString($doc, "text/xml");
                // var biomatricIndicater='';biomatricDeviceIndicater
                //console.log("doc1___",reMethodCaptures," MethodInfo_"+MethodInfo);
                // biomatricIndicater = "Biometric device connected, scan fingerprint of the customer for Aadhaar authentication";
                is_capture = true;
            },
            error: function (msg) {
                is_capture = false;
                var result = msg.status + msg.statusText + msg.responseText;
                alert(result);

            }
        });
        this.deviceInfo();

        return res;

    }

    deviceInfo = () => {
        var url = "";
        finalUrl = 'http://127.0.0.1:' + finalport;
        var verb = "DEVICEINFO";
        //alert(finalUrl);

        var err = "";
        var res;
        //$.support.cors = true;
        var httpStaus = false;
        var jsonstr = "";
        $.ajax({
            type: "DEVICEINFO",
            async: false,
            crossDomain: true,
            url: finalUrl + MethodInfo,
            contentType: "text/xml; charset=utf-8",
            processData: false,
            success: function (data) {
                var xmlstr = data.xml ? data.xml : (new XMLSerializer()).serializeToString(data);
                //alert(xmlstr);
                data = xmlstr;
                //alert(url);
                httpStaus = true;
                res = { httpStaus: httpStaus, data: data };

                $('#txtDeviceInfo').val(data);
                deviceInfo = data;
            },
            error: function (msg) {
                var result = msg.status + msg.statusText + msg.responseText;
                console.log("Error In device info", result);

            }
        });

        return res;


    }


    validateAgent = () => {
        const url = '/api/v1/yesbank/eKyc/validateAgent';

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': "ROLE_EMITRA_CSP"
        }
        const header = {
            msgType: "CREATE_ORDER",
            service: "DMT",
            src: "test",
            dst: "rtest",
            channel: "API",
            requesterId: "client.whitelabel@finxpay",
            requestId: uuidv4(),
            traceId: uuidv4(),
        }

        const otpInfo = {
            otpToken: this.state.otpToken,
            otp: "111111"// qa only

        },


            request = {
                header: header,
                otpInfo: otpInfo,
                mobileNo: this.state.mobile
            }

        httpClient.post(url, request,
            { headers }
        ).then((response) => {
            console.log('otp generate response' + JSON.stringify(response.data));
            if (response.data.response.msg == 'SUCCESS') {

                this.setState({
                    kycToken: response.data.kycToken
                })

                this.getAdharWadh();


            }
            else {
                alert(response.data.response.displayMsg);
            }
        }).catch(error => {
            alert(error.message);
            console.log(error);

        });


    }

    getAdharWadh = () => {
        const url = '/api/v1/yesbank/eKyc/getAdhaarWadh';

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': "ROLE_EMITRA_CSP"
        }
        const header = {
            msgType: "CREATE_ORDER",
            service: "DMT",
            src: "test",
            dst: "rtest",
            channel: "API",
            requesterId: "client.whitelabel@finxpay",
            requestId: uuidv4(),
            traceId: uuidv4(),
        }



        const agentInfo = {
            agentReferenceId: this.state.refId,
            otp: "111111"// qa only

        },


            request = {
                header: header,
                agentInfo: agentInfo,
                mobileNo: this.state.mobile,
                kycToken: this.state.kycToken
            }

        httpClient.post(url, request,
            { headers }
        ).then((response) => {
            console.log('response' + JSON.stringify(response.data));
            if (response.data.response.msg == 'SUCCESS') {

                this.setState({
                    wadh: response.data.wadh,
                    captureStatus: 'On'
                })

                // this.submitKyc();


            }
            else {
                alert(response.data.response.displayMsg);
            }
        }).catch(error => {
            alert(error.message);
            console.log(error);

        });


    }

    componentDidMount() {
        var id = 'DIVAYKHANNA';
        var agentInfo = {
            id: id
        }
        store.dispatch(setAgentInfo(agentInfo));
        //console.log('this.props', props.location.search)
        var discoverRDServiceResponse = this.discoverRDService();
        var discoverRDServiceFinalResponse = new XMLParser().parseFromString(discoverRDServiceResponse.data);
        // var info = "Precision - Biometric Device is not connected to the system, please connect and try again"
        var info = discoverRDServiceFinalResponse != undefined && discoverRDServiceFinalResponse.attributes.info != undefined ? discoverRDServiceFinalResponse.attributes.info : '';
        var status = discoverRDServiceFinalResponse != undefined && discoverRDServiceFinalResponse.attributes.status != undefined ? discoverRDServiceFinalResponse.attributes.status : '';//"NOTREADY"
        console.log("discoverRDServiceFinalResponse__", discoverRDServiceFinalResponse.attributes);
        if (status == "NOTREADY") {
            alert('Connect-device status ' + status);
            this.setState({ biomatricDeviceIndicaterClass: "disconnect" });
        } else {
            alert('Connect-device status ' + status);
            this.setState({ biomatricDeviceIndicaterClass: "connect" });
        }
        this.setState({ biomatricDeviceIndicater: info });
    }

    submitKyc = (event) => {
        event.preventDefault();

        var CryptoJS = require("crypto-js");
        var ciphertext = CryptoJS.AES.encrypt('1~RightThumb', '123456789');
        console.log("encrypted text", ciphertext.toString());
        var authResult = new URLSearchParams(window.location.search);

        console.log(" Request for submit biometryDetailauthResult", authResult, " window.location ", window.location)

        // var finalmdnData = this.getDecryptedValue(authResult.get('mdn'));
        // var finaluid = this.getDecryptedValue(authResult.get('uid'));
        // var final_device_finger_data = this.getDecryptedValue(authResult.get('device_finger_data'));
        // var device_serial_number = this.getDecryptedValue(authResult.get('device_serial_number'));
        // var device_session_key = this.getDecryptedValue(authResult.get('device_session_key'));
        // var device_time_stamp = this.getDecryptedValue(authResult.get('device_time_stamp'));
        // var device_type = this.getDecryptedValue(authResult.get('device_type'));
        // var device_version_number = this.getDecryptedValue(authResult.get('device_version_number'));
        // var device_cert_expiryDate = this.getDecryptedValue(authResult.get('device_cert_expiryDate'));
        // var e_kyc_type = this.getDecryptedValue(authResult.get('e_kyc_type'));
        // var captured_template = this.getDecryptedValue(authResult.get('captured_template'));
        // var device_data_xml = this.getDecryptedValue(authResult.get('device_data_xml'));
        // var device_hmac_xml = this.getDecryptedValue(authResult.get('device_hmac_xml'));

        const header = {
            msgType: "CREATE_ORDER",
            service: "DMT",
            src: "test",
            dst: "rtest",
            channel: "API",
            requesterId: "client.whitelabel@finxpay",
            requestId: uuidv4(),
            traceId: uuidv4(),
        }

        const agentInfo = {
            agentReferenceId: this.state.refId
        }
        const aadhaarInfo = {
            aadharNumber: this.state.aadharNumber,
            aadharType: 0
        }

        const ekycInfo = {
            consent: "Y",
            ekycType: "EKYC",
            capturedTemplate: "Null",
            purpose: "Authentication"
        }

        const bioMetricDeviceInfo = {
            deviceDataXml: this.state.deviceXmlData,
            fingerData: "6~RightThumb",
            serialNumber: this.state.serialNum,
            sessionKey: '',
            capturingTime: this.state.timeStamp,
            typeOfDevice: "4",
            deviceVersionNumber: this.state.version
        },

            request = {
                header: header,
                mobileNo: this.state.mobile,
                kycToken: this.state.kycToken,
                wadhValue: this.state.wadh,
                ekycInfo: ekycInfo,
                agentInfo: agentInfo,
                aadhaarInfo: aadhaarInfo,
                bioMetricDeviceInfo: bioMetricDeviceInfo
            }




        var url = '/api/v1/yesbank/eKyc/biometricKyc';

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': "ROLE_EMITRA_CSP"
        }


        httpClient.post(url, request,
            { headers }
        ).then((response) => {
            console.log('response' + JSON.stringify(response.data));
            if (response.data.response.msg == 'SUCCESS') {

                alert('agent id created successfully');
                //   alert(JSON.stringify(response.data));


            }
            else {
                alert('agent id creation failed--' + response.data.response.displayMsg);
                // alert(JSON.stringify(response.data));

            }
        }).catch(error => {
            alert(error.message);
            console.log(error);

        });

    }



    agentCreation = (event) => {

        event.preventDefault();
        const header = {
            msgType: "CREATE_ORDER",
            service: "DMT",
            src: "test",
            dst: "rtest",
            channel: "API",
            requesterId: "client.whitelabel@finxpay",
            requestId: uuidv4(),
            traceId: uuidv4(),
        }


        const agentInfo = {
            agentFullName: this.state.agentFullName,
            agentPan: this.state.agentPan,
            agentDateOfBirth: this.state.agentDateOfBirth,
            agentGender: "M",
            agentReferenceId: this.state.refId,
            agentShopName: this.state.shopName
        }

        const agentCreationRequest = {
            header: header,
            agentInfo: agentInfo,
            mobileNo: this.state.mobile
        }

        var agentCreationUrl = '/api/v1/yesbank/eKyc/agentCreation';

        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id,
            'role': "ROLE_EMITRA_CSP"
        }


        this.setState({
            req: agentCreationRequest
        })

        httpClient.post(agentCreationUrl, agentCreationRequest,
            { headers }
        ).then((response) => {
            console.log('response' + JSON.stringify(response.data));
            if (response.data.response.msg == 'SUCCESS') {
                if (response.data.agentCreationStatus == 'SUCCESS') {
                    this.setState({
                        otpToken: response.data.otpToken
                    })

                    this.validateAgent();
                }

            }
            else {
                alert(response.data.response.displayMsg);
            }
        }).catch(error => {
            alert(error.message);
            console.log(error);

        });
    }



    render() {


        return (




            <div class="main">



                <div class="container-fluid">



                    <div class="row">
                        <div class="col-12">
                            <div class="card-b" id="rightdiv">
                                <div id="recenttxn">

                                    <div style={{ display: 'none' }} >
                                        <input type="hidden" value="1" id="txtfcount" className="form-control" />
                                        <input type="hidden" value="1" id="txtftype" className="form-control" />
                                        <input type="hidden" value="0" id="txtformat" className="form-control" />
                                        <input type="hidden" value="2.0" id="txtPidVer" className="form-control" />
                                        <input type="tehiddenxt" value="10000" id="txttimeout" className="form-control" />
                                        {/* <input type="hidden" value="P" id="txtenv" className="form-control" /> */}
                                        <input type="hidden" value="PP" id="txtenv" className="form-control" />
                                        <input type="text" value={this.state.wadh} id="wadh_value" className="form-control" />
                                        <input type="hidden" value="" id="txtlk" className="form-control" />
                                        <textarea id="txtRDSInfo" className="form-control hide"> </textarea>
                                        <textarea id="txtDeviceInfo" className="form-control hide"> </textarea>
                                        <textarea id="txtPidData" className="form-control hide"> </textarea>
                                        <select id="ddlRDS" className="form-control hide"  ><option></option></select>
                                    </div>


                                    <form onSubmit={this.agentCreation}>
                                        <div class="dashform">
                                            <div class="row">
                                                <div class="col-12 col-lg-8">

                                                    <div class="row">


                                                        <div class="col-12 col-sm-6">
                                                            <div class="form-floating">
                                                                <input type="text" class="form-control" id="name" placeholder="Agent Name"
                                                                    // onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                                                                    // onChange={this.senderMobile}
                                                                    // required/>
                                                                    value='PRAKASH RAM JHUNJHUNWALA' readOnly>
                                                                </input>
                                                                <label for="name">Agent Name</label>
                                                            </div>
                                                        </div>

                                                        <div class="col-12 col-sm-6">
                                                            <div class="form-floating">
                                                                <input type="text" class="form-control" id="pan" placeholder="Agent PAN"
                                                                    // onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                                                                    // onChange={this.senderMobile}
                                                                    // required/>
                                                                    value='AAIPM3854E' readOnly>
                                                                </input>
                                                                <label for="pan">Agent pan</label>
                                                            </div>
                                                        </div>

                                                        <div class="col-12 col-sm-6">
                                                            <div class="form-floating">
                                                                <input type="text" class="form-control" id="DOB"
                                                                    placeholder="Agent DOB"
                                                                    // onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                                                                    // onChange={this.senderMobile}
                                                                    // required/>
                                                                    value='22/07/1989' readOnly>
                                                                </input>
                                                                <label for="DOB">Agent DOB</label>
                                                            </div>
                                                        </div>


                                                        <div class="col-12 col-sm-6">
                                                            <div class="form-floating">
                                                                <input type="text" class="form-control" id="refid"
                                                                    placeholder="Agent RefId"
                                                                    onInput={(e) => e.target.value = e.target.value.slice(0, 15)}
                                                                    onChange={this.enterRefId}
                                                                    required />


                                                                <label for="refid">Agent Reference Id</label>
                                                            </div>
                                                        </div>

                                                        <div class="col-12 col-sm-6">
                                                            <div class="form-floating">
                                                                <input type="text" class="form-control" id="shop"
                                                                    placeholder="Agent Shop Name"
                                                                    onInput={(e) => e.target.value = e.target.value.slice(0, 15)}
                                                                    onChange={this.enterShop}
                                                                    required />


                                                                <label for="shop">Agent Shop Name</label>
                                                            </div>
                                                        </div>




                                                        <div class="col-12 col-sm-6">
                                                            <div class="form-floating">
                                                                <input type="number" class="form-control" id="pan" placeholder="Agent Mobile"
                                                                    onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                                                                    onChange={this.enterMobile}
                                                                    required />


                                                                <label for="pan">Agent Mobile</label>
                                                            </div>
                                                        </div>





                                                    </div>
                                                    {this.state.wadh == '' &&
                                                        <button class="dbbtn" type="submit">Create Agent</button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </form>

                                    {this.state.submitBtnStatus == true &&
                                        <form onSubmit={this.submitKyc}>
                                            <div class="dashform">
                                                <div class="row">
                                                    <div class="col-12 col-lg-8">

                                                        <div class="row">


                                                            <div class="col-12 col-sm-6">
                                                                <div class="form-floating">

                                                                    <input type="number" class="form-control" id="pan" placeholder="Adahar  Number"
                                                                        // onInput={(e) => e.target.value = e.target.value.slice(0, 10)}
                                                                        onChange={this.enterAadhar}
                                                                        required />


                                                                    <label for="Aadhar">Aadhar Number</label>
                                                                    <br />

                                                                    <button class="dbbtn" type="submit">Submit Kyc</button><br />

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    }


                                    <div class="dashform">
                                        <div class="row">
                                            <div class="col-12 col-lg-8">

                                                <div class="row"></div>
                                                {/* {this.state.otpToken!='' &&
                                            	        <div class="form-floating">
                                                            <textarea>{"otp token:"+this.state.otpToken}</textarea>
                                                    <br/>
                                                        </div>
                                                    } */}

                                                {/* {this.state.kycToken!='' &&
                                            	<div class="form-floating">
                                               <textarea>{"kyc token:"+this.state.kycToken}</textarea>
                                               <br/>
                                               
                                               
                                                 </div>
                                            } */}

                                                {/* {this.state.wadh!='' &&
                                            	<div class="form-floating">
                                               <textarea>{"wadh value:"+this.state.wadh}</textarea>
                                               <br/>
                                               
                                               
                                                 </div>
                                            }  */}
                                                {this.state.captureStatus == 'On' &&
                                                    this.state.submitBtnStatus == false &&
                                                    <div>
                                                        <button class="dbbtn" onClick={this.captureFingerPrint} type="button">Capture Finger Print</button><br /></div>
                                                }
                                                <br />
                                                <textarea placeholder="Captured FingerPrint Data">
                                                    {capturedData}
                                                </textarea>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        miscReduce: { phone, deviceInfo, agentInfo, token } }
    ,
) => ({
    errorMessage, loginErrorMessage, phone, deviceInfo, agentInfo, token
});

export default connect(mapStateToProps, null)(AddSender);
